import { Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import homeImage from "../../assets/landingScreen/Home.svg";
import { getDefPromt, isIos, isFirefox } from "../../lib/utility"; // <-- added isFirefox
import style from "./success.module.css";

var deferredPrompt;
var started = 0;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddToHomeScreen = () => {
  const [appInstalled, setAppInstalled] = useState(false);
  const [alreadyInstalled, setAlreadyInstalled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      deferredPrompt = e;
    });

    window.addEventListener("appInstalled", () => {
      setAppInstalled(true);
    });
  }, []);

  const handleProceedClick = () => {
    navigate("/");
  };

  const isIosModel = isIos();
  const isFirefoxModel = isFirefox();

  const handleInstallClick = () => {
    var deferredPrompt = getDefPromt();
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          if (started === 0) {
            started = 1;
          } else {
            setAlreadyInstalled(true);
          }
        } else {
          console.log("User dismissed the install prompt");
        }
      });
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <Snackbar
        open={appInstalled}
        autoHideDuration={3000}
        onClose={() => setAppInstalled((prev) => !prev)}
        sx={{
          position: "absolute",
          top: "10%",
        }}
      >
        <Alert
          onClose={() => setAppInstalled((prev) => !prev)}
          sx={{ width: "100%", backgroundColor: "white" }}
        >
          <h4 style={{ color: "black", textAlign: "center" }}>
            App is installed
          </h4>
        </Alert>
      </Snackbar>

      <Snackbar
        open={alreadyInstalled}
        autoHideDuration={3000}
        onClose={() => setAlreadyInstalled((prev) => !prev)}
        sx={{
          position: "absolute",
          top: "10%",
        }}
      >
        <Alert
          onClose={() => setAlreadyInstalled((prev) => !prev)}
          sx={{ width: "100%", backgroundColor: "white" }}
        >
          <h4 style={{ color: "black", textAlign: "center" }}>
            App is already installed
          </h4>
        </Alert>
      </Snackbar>

      <Box
        sx={{
          display: "grid",
          height: "100svh",
          gridTemplateRows: "50px auto 90px",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#F07821",
            height: 50,
            padding: "0.7rem 1rem",
          }}
        >
          <h4
            style={{
              fontSize: "1.0625rem",
              fontWeight: "500",
              color: "white",
            }}
          >
            Add to Home Screen
          </h4>
          {!(isIosModel || isFirefoxModel) && (
            <AiOutlineClose
              style={{ color: "white" }}
              onClick={() => navigate("/")}
            />
          )}
        </Box>

        <Box
          style={{
            display: "flex",
            flex: "1",
            flexDirection: "column",
            gap: 15,
          }}
        >
          <Box className={style.home_container}>
            <img src={homeImage} style={{ width: "5rem" }} />
            <h4 className={style.home_description}>
              To track your earnings, we recommend you add this App to Home
              Screen with a simple click
            </h4>
          </Box>

          {(isIosModel || isFirefoxModel) && (
            <Box sx={{ padding: "15px 15px 15px 35px" }}>
              <ul>
                <li>
                  Tap the <strong>Share</strong> icon in your browser.
                </li>
                <li>
                  Select <strong>Add to Home Screen</strong>.
                </li>
                {/* <li>
                  Choose a name for the shortcut and tap <strong>Add</strong>.
                </li> */}
              </ul>
            </Box>
          )}
        </Box>

        <div style={{ padding: "15px" }}>
          <Box
            className={style.shareButton}
            sx={{
              backgroundColor: "#8647AF",
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => {
              isIosModel || isFirefoxModel
                ? handleProceedClick()
                : handleInstallClick();
            }}
          >
            {isIosModel || isFirefoxModel
              ? "Proceed"
              : "Add to Home screen"}
          </Box>
        </div>
      </Box>
    </>
  );
};

export default AddToHomeScreen;
